/**
 * Вес и длительность файла словами, для текстов про аудио и видео. Читают форма
 * выдачи домашки (`homework/assign/material.ts`) и лента ученика
 * (`exercises/material-order.ts`), поэтому модуль без единого импорта: в чанк
 * ученика он не тянет ничего формы.
 *
 * Неразрывный пробел держит число рядом с единицей: строка веса не
 * переносится посреди числа.
 */

/** «85 МБ». Не меньше единицы: «0 МБ» у файла читалось бы как ошибка. */
export function megabytesText(bytes: number): string {
  return `${Math.max(1, Math.round(bytes / (1024 * 1024)))} МБ`;
}

/** «45 с», «4 мин». Минуты округлены: у длинной записи секунды не нужны. */
export function minutesText(ms: number): string {
  const sec = Math.round(ms / 1000);
  if (sec < 60) return `${Math.max(1, sec)} с`;
  return `${Math.round(sec / 60)} мин`;
}
